// extracted by mini-css-extract-plugin
export var discard = "_1t-4";
export var muiTooltipTooltip = "_1t-6";
export var notificationBar = "_1t-3";
export var notificationContainer = "_1t-2";
export var saveButtonHoverSlotWrapper = "_1t-5";
export var show = "_1t-1";
export var spacer = "_1t-0";